export default [
	{
		path: '/aiPoints/package',
		name: 'AiPointsPackage',
		component: () => import('../views/aiPoints/package'),
		meta: {
			title: 'AI资源点-套餐管理',
			keepAlive: false
		}
	},
	{
		path: '/aiPoints/order',
		name: 'AiPointsOrder',
		component: () => import('../views/aiPoints/order'),
		meta: {
			title: 'AI资源点-订单管理',
			keepAlive: false
		}
	}
]

